import React from "react";
import "./NewSticker.scss";

const NewSticker = () => {
  return <p className="NewSticker">NEW!</p>;
};

export default NewSticker;
